import React from 'react';
import { Button } from '../../../components/ui/button';
import { Card, CardHeader, CardContent } from '../../../components/ui/card';
import { ArrowRight } from 'lucide-react';

const PricingTeaser = () => {
  const plans = [
    {
      name: 'Free',
      price: 0,
      description: 'Track up to 100 changes per month',
    },
    {
      name: 'Pro',
      price: 79,
      description: 'Advanced features & prioritized support',
      popular: true
    },
    {
      name: 'Enterprise',
      description: 'Custom solutions for large teams',
      custom: true
    }
  ];

  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Simple, Transparent Pricing</h2>
          <p className="text-xl text-gray-600">Start for free, upgrade as you grow</p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            {plans.map((plan) => (
              <Card key={plan.name} className={`${
                plan.popular ? 'border-blue-200 shadow-lg' : 'border-gray-200'
              }`}>
                <CardHeader className="p-6">
                  <h3 className="text-lg font-semibold text-gray-900">{plan.name}</h3>
                  <div className="mt-2">
                    {!plan.custom ? (
                      <div className="flex items-baseline">
                        <span className="text-3xl font-bold">${plan.price}</span>
                        <span className="text-gray-500 ml-1">/mo</span>
                      </div>
                    ) : (
                      <div className="text-2xl font-bold">Custom Pricing</div>
                    )}
                  </div>
                  <p className="mt-2 text-sm text-gray-600">{plan.description}</p>
                </CardHeader>
                <CardContent className="p-6 pt-0">
                  <Button 
                    className="w-full"
                    variant={plan.popular ? 'default' : 'outline'}
                    onClick={() => window.location.href = '/pricing'}
                  >
                    Compare Plans
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingTeaser;